import React, { useState, useEffect, useDebugValue } from 'react';

import InputDocuments from './InputDocuments';
import LoadingAnimation from './LoadingAnimation';
import AnalysisResult from './AnalysisResult';
import StartAnalysis from './StartAnalysis';
import LoadingStatic from './LoadingStatic';
import filesService from 'services/files.service';

import example1 from '../../assets/txt/example-1.json';
import example2 from '../../assets/txt/example-2.json';
import example3 from '../../assets/txt/example-3.json';
import AnalysisPlaceholder from './AnalysisPlaceholder';
import MiniLogin from 'components/Login/MiniLogin';

const Analysis = ({ id }) => {

    const [analysisResult, setAnalysisResult] = useState(null);
    const [subastaId, setSubastaId] = useState(null);
    const [accessError, setAccessError] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState('Analizando documentos...');
    const [secondsElapsed, setSecondsElapsed] = useState(0);

    const messages = [
        "Estamos procesando los documentos...",
        "Extrayendo información detallada del Registro...",
        "La IA está analizando las cargas y gravámenes...",
        "Generando informe detallado de cancelación de cargas...",
        "¡Ya casi está listo! Analizando riesgos finales...",
        "Refinando el resultado final para tu seguridad..."
    ];

    useEffect(() => {
        if (!id) return;
        switch (id) {
            case 'ejemplo-1':
                setAnalysisResult(example1);
                break;
            case 'ejemplo-2':
                setAnalysisResult(example2);
                break;
            case 'ejemplo-3':
                setAnalysisResult(example3);
                break;
            default:
                getAnalysis(id);
                break;
        }
    }, [id]);

    useEffect(() => {
        if (analysisResult || accessError || !id) return;

        const timer = setInterval(() => {
            setSecondsElapsed(prev => prev + 1);
        }, 1000);

        const poller = setInterval(() => {
            if (!analysisResult) {
                getAnalysis(id);
            }
        }, 5000);

        return () => {
            clearInterval(timer);
            clearInterval(poller);
        };
    }, [analysisResult, accessError, id]);

    useEffect(() => {
        if (secondsElapsed >= 120) {
            setLoadingMessage('Esto está tardando más de lo esperado, pero seguimos trabajando en ello...');
        } else {
            const messageIndex = Math.min(Math.floor(secondsElapsed / 15), messages.length - 1);
            setLoadingMessage(messages[messageIndex]);
        }
    }, [secondsElapsed]);

    const getAnalysis = async (id) => {
        try {
            const response = await filesService.getAnalysis(id);
            if (response.status === 200) {
                const data = response.data.analysis;
                if (data) {
                    console.log("Analysis retrieved successfully!");
                    setAnalysisResult(JSON.parse(data));
                    setSubastaId(response.data.subastaId);
                }
            }
        } catch (error) {
            console.error("Error getting analysis:", error);
            if (error.response && error.response.status === 401) {
                setAccessError(true);
            }
        }
    };

    const updateUser = () => {
        setAccessError(false);
        getAnalysis(id);
    };

    return (
        <div className="h-full w-full flex flex-col items-center">
            <div className={`flex w-full h-full flex-col`}>
                {!accessError && !analysisResult && (
                    <div className="w-full flex flex-col items-center justify-center py-12 px-4">
                        <div className="mb-8 relative mt-16 scale-150">
                            <div className="w-16 h-16 border-4 border-blue-100 border-t-blue-600 rounded-full animate-spin"></div>
                            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                                <i className="fas fa-brain text-blue-600 animate-pulse"></i>
                            </div>
                        </div>
                        <h2 className="text-xl font-bold text-gray-800 mb-2 text-center">
                            {loadingMessage}
                        </h2>
                        <p className="text-sm text-gray-500 text-center max-w-md">
                            Nuestro sistema basado en IA está leyendo cientos de líneas de certificaciones registrales para darte el análisis más preciso.
                        </p>
                        <div className="w-full max-w-lg mt-12 bg-white/50 backdrop-blur-sm rounded-2xl p-6 shadow-sm border border-gray-100">
                           <AnalysisPlaceholder />
                        </div>
                    </div>
                )}
                {!accessError && analysisResult && <AnalysisResult data={analysisResult} subastaId={subastaId} />}
                {accessError && <MiniLogin title={'Inicia sesión para acceder a tu informe'} updateUser={updateUser} />}
            </div>
        </div>
    );
};
export default Analysis;